module.exports = __webpack_public_path__ + "img/farming_33.1d9e6c5d.png";